export const PRIME_TRANSLATIONS_KEYS: string[] = [
    'primeng.today',
    'primeng.prevWeek',
    'primeng.currentWeek',
    'primeng.prevMonth',
    'primeng.currentMonth',
    'primeng.from',
    'primeng.to',
    'primeng.dayNames.0',
    'primeng.dayNames.1',
    'primeng.dayNames.2',
    'primeng.dayNames.3',
    'primeng.dayNames.4',
    'primeng.dayNames.5',
    'primeng.dayNames.6',
    'primeng.clear',
    'primeng.dayNamesMin.0',
    'primeng.dayNamesMin.1',
    'primeng.dayNamesMin.2',
    'primeng.dayNamesMin.3',
    'primeng.dayNamesMin.4',
    'primeng.dayNamesMin.5',
    'primeng.dayNamesMin.6',
    'primeng.dayNamesShort.0',
    'primeng.dayNamesShort.1',
    'primeng.dayNamesShort.2',
    'primeng.dayNamesShort.3',
    'primeng.dayNamesShort.4',
    'primeng.dayNamesShort.5',
    'primeng.dayNamesShort.6',
    'primeng.monthNames.0',
    'primeng.monthNames.1',
    'primeng.monthNames.2',
    'primeng.monthNames.3',
    'primeng.monthNames.4',
    'primeng.monthNames.5',
    'primeng.monthNames.6',
    'primeng.monthNames.7',
    'primeng.monthNames.8',
    'primeng.monthNames.9',
    'primeng.monthNames.10',
    'primeng.monthNames.11',
    'primeng.monthNamesShort.0',
    'primeng.monthNamesShort.1',
    'primeng.monthNamesShort.2',
    'primeng.monthNamesShort.3',
    'primeng.monthNamesShort.4',
    'primeng.monthNamesShort.5',
    'primeng.monthNamesShort.6',
    'primeng.monthNamesShort.7',
    'primeng.monthNamesShort.8',
    'primeng.monthNamesShort.9',
    'primeng.monthNamesShort.10',
    'primeng.monthNamesShort.11',
];
